import { generalData_Types } from "./general-data.types";

export const setOnlineUsersData = ({ list, page }) => ({
  type: generalData_Types.SET_ONLINE_USERS,
  payload: { list, page },
});

export const addOnlineUser = (user) => ({
  type: generalData_Types.ADD_ONLINE_USER,
  payload: user,
});

export const removeOnlineUser = (userId) => ({
  type: generalData_Types.REMOVE_ONLINE_USER,
  payload: userId,
});

export const setOnlineUsersBadge = (count) => ({
  type: generalData_Types.SET_ONLINE_USERS_BADGE,
  payload: count,
});

export const setNotifications = (notifications) => ({
  type: generalData_Types.SET_NOTIFICATIONS,
  payload: notifications,
});

/**
 * action for setting display status of notif-popup
 * @param {boolean} show
 */
export const setShowPopupNotifDisplay = (show) => ({
  type: generalData_Types.SET_SHOW_NOTIF_POPUP_DISPLAY,
  payload: show,
});

export const setFetchOnlineUsersLoadingStatus = (status) => ({
  type: generalData_Types.SET_FETCH_ONLINE_USERS_LOADING_STATUS,
  payload: status,
});

export const resetStoreState = () => ({
  type: generalData_Types.RESET_STORE_STATE,
});
